const AccordArrow = () => {
  return (
    <svg width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.1075 7.01228L7.12444 1.02928C7.08539 0.990231 7.02207 0.990232 6.98302 1.02928L1.00002 7.01228" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
};

export default AccordArrow;